<template>
  <div class="changeGoods">
    <div class="goods_batch_name">
      <span class="good_label">商品名称：</span>
      <span class="good_value">{{subData.name}}</span>
    </div>
    <div class="goods_batch_supplier">
      <span class="good_label">销售包装：</span>
      <span class="good_value">{{pack_list[subData.bale-1].name}}</span>
    </div>
    <div class="goods_batch_supplier" v-if="subData.bale == 1 || subData.bale == 2">
      <span class="good_label">销售单位：</span>
      <span class="good_value">{{unit_list[subData.num_unit-1].name}}</span>
    </div>
    <div class="goods_batch_supplier" v-if="subData.bale == 1">
      <span class="good_label">销售规格：</span>
      <span class="good_value">{{subData.bale_num}}公斤 / {{unit_list[subData.num_unit-1].name}}</span>
    </div>
    <div class="goods_batch_weight goods_input" v-if="subData.bale == 1 || subData.bale == 2">
      <span class="good_label">销售数量 
        <!-- <span>(必填)</span> -->
        </span>
      <div class="good_input">
        <KeyBoardInput v-model="subData.num" :k_placeholder="placeholderData.num" :k_decimal="2">
          <template slot="input_right">
            <div class="input_right">{{unit_list[subData.num_unit-1].name}}</div>
          </template>
        </KeyBoardInput>
      </div>
    </div>
    <div class="goods_batch_weight goods_input" v-if="subData.bale == 2 || subData.bale == 3">
      <span class="good_label">销售重量 
        <!-- <span>(必填)</span> -->
        </span>
      <div class="good_input">
        <KeyBoardInput v-model="subData.weight" :k_placeholder="placeholderData.weight" :k_decimal="2">
          <template slot="input_right">
            <div class="input_right">公斤</div>
          </template>
        </KeyBoardInput>
      </div>
    </div>
    <div class="goods_batch_weight goods_input">
      <span class="good_label">销售单价 
        <!-- <span>(必填)</span> -->
        </span>
      <div class="good_input">
        <KeyBoardInput v-model="subData.price" :k_placeholder="placeholderData.price" :k_decimal="2">
          <template slot="input_right">
            <div class="input_right">元 / {{subData.bale != 1?'公斤':unit_list[subData.num_unit-1].name}}</div>
          </template>
        </KeyBoardInput>
      </div>
    </div>
    <div class="goods_batch_num">
      <span class="good_label">批次号：</span>
      <span class="good_value">{{subData.batch}}</span>
    </div>
    <div class="goods_batch_supplier">
      <span class="good_label">货主：</span>
      <span class="good_value">{{subData.supplier_name}}</span>
    </div>
    <div class="goods_batch_type">
      <span class="good_label">类型：</span>
      <span class="good_value" v-if="subData.type == 1">自营</span>
      <span class="good_value" v-if="subData.type == 2">代卖</span>
    </div>
    <!-- <div class="goods_batch_pack goods_btn">
      <span class="good_label">销售包装</span>
      <div class="good_pack goods_btns"> 
        <span v-for="(item,index) in pack_list" :key="index" :class="subData.bale == item.value?'active':''" @click="subData.bale = item.value">{{item.name}}</span>
      </div>
    </div> -->
    <!-- <div class="goods_batch_unit goods_btn" v-if="subData.bale == 1 || subData.bale == 2">
      <span class="good_label">销售单位</span>
      <div class="good_pack goods_btns">
        <span v-for="(item,index) in unit_list" :key="index" :class="subData.num_unit == item.value?'active':''" @click="subData.num_unit = item.value">{{item.name}}</span>
      </div>
    </div> -->
    <!-- <div class="goods_batch_weight goods_input" v-if="subData.bale == 1">
      <span class="good_label">规格 <span>(必填)</span></span>
      <div class="good_input">
        <input type="number" v-model="subData.bale_num" :min="0" :placeholder="placeholderData.bale_num">
        <span>公斤 / {{unit_list[subData.num_unit-1].name}}</span>
      </div>
    </div> -->
    <div class="good_save" @click="setData">
      确  认
    </div>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import { changeGoods_get ,changeGoods_set} from "@/api/work/order/openOrder"
import { isPosFloat } from "@/utils/validate"
export default {
  name: 'changeGoods',
  components:{
    KeyBoardInput
  },
  data(){
    return {
      pack_list:[{value:1,name:'定装'},{value:2,name:'非定装'},{value:3,name:'散装'}],
      unit_active:'1',
      unit_list:[{value:1,name:'件'},{value:2,name:'包'},{value:3,name:'袋'},{value:4,name:'盒'},{value:5,name:'瓶'},{value:6,name:'箱'},{value:7,name:'罐'}],
      subData:{
        id:'',
        batch:'',  //批次号
        supplier_name:'', // 货主名字
        type:'1', //1自营，2代卖
        name:'',//  
        unit:2, //1斤，2公斤。添加时必填 默认为2
        bale:1, // 销售包装 正装 
        num_unit:1, // 单位 
        num:"", // 数量  
        bale_num:"", // 规格 bale==1 必传
        weight:"", // 销售重量
        price:"", // 单价
        goods_type:1
      },

      placeholderData:{
        num:"", // 数量  
        bale_num:"", // 规格 bale==1 必传
        weight:"", // 销售重量
        price:"", // 单价
      }
    }
  },
  created(){
    if(this.$route.meta.backData){
      delete this.$route.meta.backData
    }
    this.getData({batch:this.$route.query.batch})
  },
  mounted(){




  },
  methods:{
    // 获取批次数据
    getData(subData){
      changeGoods_get(subData).then(res=>{
        if(res.code == 200){
          var data = res.data
          this.subData.id = data.id          
          this.subData.batch = data.batch          
          this.subData.supplier_name = data.supplier_name
          this.subData.type = data.type
          this.subData.name = data.name
          this.subData.bale = data.bale-0
          this.subData.num_unit = data.num_unit-0 // 单位
          this.subData.bale_num = data.bale_num? Number(data.bale_num):'' + ""  // 规格
          // this.subData.weight = data.weight? Number(data.weight):''  + ""  // 重量
          // this.subData.num = data.num? Number(data.num):''
          // this.subData.price = data.price? Number(data.price):''  + "" // 单价
          this.subData.price = "" // 单价

          
          this.placeholderData.num = data.num? Number(data.num):''
          this.placeholderData.bale_num = data.bale_num? Number(data.bale_num):'' + ""  // 规格
          this.placeholderData.weight = data.weight? Number(data.weight):''  + ""  // 重量
        }
      })
    },
    // 提交数据
    setData(){
      this.subData.num = this.subData.num ? this.subData.num:this.placeholderData.num
      this.subData.bale_num = this.subData.bale_num ? this.subData.bale_num:this.placeholderData.bale_num
      this.subData.weight = this.subData.weight ? this.subData.weight:this.placeholderData.weight
      if(!this.subData.name){ this.$toast("请输入商品名称！"); return false }
      if(this.subData.bale == 1 && !(this.subData.bale_num>0)){ this.$toast("请输入商品规格！"); return false }
      if(this.subData.bale == 1 && !(Number(this.subData.num).toFixed(2)>0)){ this.$toast("请输入商品销售数量！"); return false }
      if(this.subData.bale == 2 && !(Number(this.subData.num).toFixed(2)>0)){ this.$toast("请输入商品销售数量！"); return false }
      if(this.subData.bale == 2 && !(Number(this.subData.weight).toFixed(3)>0)){ this.$toast("请输入商品销售重量！"); return false }
      if(this.subData.bale == 3 && !(Number(this.subData.weight).toFixed(3)>0)){ this.$toast("请输入商品销售重量！"); return false }
      if(!(Number(this.subData.price).toFixed(2)>0)){ this.$toast("请输入商品单价！"); return false }
      var subData = JSON.parse(JSON.stringify(this.subData))
      subData.weight = Number(Number(subData.weight).toFixed(3))
      subData.bale_num = Number(Number(subData.bale_num).toFixed(3))
      subData.num = Number(Number(subData.num).toFixed(3))
      subData.price = Number(Number(subData.price).toFixed(3))
      delete subData.supplier_name
      delete subData.id
      if(subData.bale == 1){
        subData.weight = subData.bale_num * subData.num 
      }
      this.$route.meta.backData = JSON.stringify(subData)
      this.$router.go(-2)
      // changeGoods_set(subData).then(res=>{
      //   if(res.code == 200){
      //     this.$route.meta.backData = JSON.stringify(subData)
      //     this.$router.go(-2)
      //   }
      // })
    }
    
  }
}
</script>

<style lang="less" scoped>
.changeGoods{
  position: relative;
  min-height: calc(100vh - 0.88rem);
  background-color: #fff;
  padding: 0.3rem ;
  box-sizing: border-box;
  &>div{
    overflow: hidden;
  }
  .good_label{
    font-size: 0.34rem;
    color: #333;
    line-height: 0.6rem;  
    span{
      font-size: 0.28rem;
      color: #FB5353;
    }
  }
  .good_value{
    color: #999;
    font-size: 0.34rem;
  }
  .goods_batch_name{
    .good_value{
      color: #E89011;
    }
  }
  .goods_btn{
    padding-bottom: 0.15rem;
    border-bottom: 0.01rem solid #ccc;
    margin-bottom: 0.15rem;
    .goods_btns{
      margin-top: 0.1rem;
      span{
        display: inline-block;
        padding: 0 0.4rem;
        line-height: 0.6rem;
        background-color: #E6E6E6;
        border-radius: 0.3rem;
        text-align: center;
        margin-right: 0.2rem;
        color: #999;
        letter-spacing: 0.05rem;
        margin-bottom: 0.1rem;
        &.active{
          background:rgba(49,177,88,0.2);
          color: #31B158;
        }
      }
    }
  }
  .goods_input{
    padding-bottom: 0.1rem;
    .good_input{
      position: relative;
      box-sizing: border-box;
      height: 0.82rem;
      background-color: #f5f5f5;
      padding-right: 0.3rem;
      border: 0.01rem solid #ccc;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input{
        width: 70%;
        line-height: 0.8rem;
        font-size: 0.34rem;
        text-indent: 0.2rem;
        border-radius: 0.1rem;
        background-color: #f5f5f5;
        box-sizing: border-box;
      }
      span{
        line-height: 0.8rem;
        padding-right: 0.2rem;
      }
    }
  }
  .good_save{
    background-color: #31B158;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 1rem;
    font-size: 0.36rem;
    color:#fff;
    letter-spacing: 0.1rem;
    border-radius: 0.1rem;
    &[disabled]{
      background-color: #B3B3B3;
    }
  }
}
</style>